import React from 'react'
import {connect} from 'react-redux'
import {Field, autofill, reduxForm, getFormValues, reset, getFormMeta} from 'redux-form'
import withRouterLegacy from 'withRouterLegacy'
import {get} from 'lodash'
import {getState} from 'utils'
import {actionCreators} from 'actions'
import AdditionalSearchFields from 'employees/list/AdditionalSearchFields'
import styles from 'employees/list/SearchForm.scss'
import searchDetector from 'searchDetector'
import {MainFormControls, SearchEmploymentStatusField} from 'jbc-front/components/SearchForm'

import {
  formName,
  convertQueryToForm,
  getCurrentQueryFromLocation,
  fetchDocumentEmployees,
  convertFormToQueryString,
  fetchSelections,
  hasConditions,
} from 'documentEmployees/list/utils'
import compose from 'lodash/fp/compose'
import moment from 'moment'

export const employmentStatuses = [
  {id: 'all', name: 'すべて'},
  {id: 'employed', name: '在職中'},
  {id: 'vacation', name: '休職中'},
  {id: 'unemployed', name: '退職済'},
  {id: 'join', name: '内定'},
]

class SearchFormWithCardList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isExpand: false,
    }
  }

  componentDidMount() {
    const {token, dispatch} = this.props
    fetchSelections(token, dispatch)
  }

  componentWillUnmount() {
    this.props.dispatch(actionCreators.fetchDestroy('selections'))
  }

  clearForm = () => {
    const {dispatch, history, location} = this.props
    getState(dispatch).then(() => {
      dispatch(reset(formName))
      history.push({...location, search: ''})
    })
  }

  render() {
    const {formValues, handleSubmit} = this.props
    return (
      <div className={styles.searchForm}>
        <form onSubmit={handleSubmit}>
          <div className={styles.mainSearchFields}>
            <Field
              name="employment_status"
              component={SearchEmploymentStatusField}
              employmentStatuses={employmentStatuses}
              onEmploymentStatusChange={handleSubmit}
            />
            <MainFormControls
              isExpand={this.state.isExpand}
              hasConditions={hasConditions(formValues)}
              handleClear={this.clearForm}
              onToggleClick={() => {
                this.setState({isExpand: !this.state.isExpand})
              }}
            />
          </div>
          {this.state.isExpand && <AdditionalSearchFields showJoinedStatusField={false} showAddedField={false} />}
        </form>
      </div>
    )
  }
}

const validate = (values) => {
  const errors = {}
  if (values.age_from && values.age_to && +values.age_from > +values.age_to) {
    errors.age_to = errors.age_from = 'の範囲が正しくありません'
  }
  if (
    [values['joined_at_start'], values['joined_at_end']].every(
      (date) => date && moment(date, 'YYYY/MM/DD').isValid()
    ) &&
    moment(values['joined_at_start'], 'YYYY/MM/DD').diff(moment(values['joined_at_end'], 'YYYY/MM/DD'), 'days') > 0
  ) {
    errors['joined_at_start'] = errors['joined_at_end'] = 'の範囲が正しくありません'
  }
  return errors
}

export default compose(
  searchDetector({
    convertQueryToForm,
    convertFormToQueryString,
    getCurrentQueryFromLocation,
    fetchData(query, additionalParams, dispatch) {
      dispatch(fetchDocumentEmployees(query, additionalParams))
    },
    destroy(dispatch) {
      dispatch(actionCreators.documentEmployees.list.destroy())
    },
  }),
  withRouterLegacy,
  connect((state) => ({
    token: state.auth.token,
    formValues: getFormValues(formName)(state),
    user: state.session.currentUser,
  })),
  reduxForm({
    form: formName,
    enableReinitialize: true,
    validate,
    onSubmit(values, dispatch, {handleSearch}) {
      getState(dispatch).then((state) => {
        const autofilled = get(getFormMeta(formName)(state), 'page.autofilled')
        if (!autofilled) {
          dispatch(autofill(formName, 'page', 1))
        }
        getState(dispatch).then((state) => {
          handleSearch(getFormValues(formName)(state))
        })
      })
    },
  })
)(SearchFormWithCardList)
